module.exports = __webpack_public_path__ + "img/piatkowski2.65440d21.png";